import type { PickerResource } from '@/types/picker';

/**
 * Get URL from a picker resource, handling both SDK formats.
 */
export const getPickerResourceUrl = (resource: PickerResource): string => {
  return resource.value?.location || resource.location || '';
};

/**
 * Check if a picker resource is a video based on type/mediaType/URL.
 */
export const isPickerResourceVideo = (resource: PickerResource): boolean => {
  const url = getPickerResourceUrl(resource);
  return (
    resource.type === 'video' ||
    resource.mediaType === 'VIDEO' ||
    url.includes('.mp4') ||
    url.includes('.mov')
  );
};
